import React from 'react';
import {findDOMNode} from "react-dom";
import GDLink from "../../../gd-components/gd-link";

export enum AppMainType {
    WITH_CONTROLS   = 'with-controls',
    FULL   = 'full',
    SIDE   = 'side',
    FORM   = 'form',
    FORM_BIG   = 'form-big',
}

type Props = {
    children        : any,

    className?      : string

    title?          : string
    type            : AppMainType | "full" | "main" | "with-controls"
    navigation?      : any[]
    filterTypeEdge? : number

    rightContainerOpen?: boolean,

    navigationHandler?  : callback
    onScroll?           : callback
}

export default class AppMain extends React.Component<Props> {

    public overlap          : boolean   = false
    public node             : any
    public debouncedSizeChanged             : any

    // static defaultProps = {
    //     // title: null,
    //     // navigation: null,
    //
    //     // filterTypeEdge: 1200,
    //     // rightContainerOpen: false
    // };

    constructor(props:Props) {
        super(props);
    }

    private get filterTypeEdge():number {
        return _.get(this.props, 'filterTypeEdge', 1200)
    }

    addClass(className:string, ref?:any) {
        const node = findDOMNode(ref ? ref : this);
        if (node) {
            // @ts-ignore
            node.classList.add(className);
        }
    }

    removeClass(className:string, ref?:any) {
        const node = findDOMNode(ref ? ref : this);
        if (node) {
            // @ts-ignore
            node.classList.remove(className);
        }
    }

    toggleClass(className:string, value:any, ref:any) {
        value ? this.addClass(className, ref) : this.removeClass(className, ref)
    }

    componentDidMount() {
        this.node = findDOMNode(this);
        this.debouncedSizeChanged = _.debounce(this.onSizeChanged, 300);

        gd.bus.subscribe("rightContainer:show",this,this.showRightContainer);

        gd.layout.on("change:widthMain",this.debouncedSizeChanged,this);
        gd.layout.on('change:heightMain',this.debouncedSizeChanged,this);

        this.node.addEventListener('click', this.handleAppMainClick, true);
    }

    componentWillUnmount() {
        gd.bus.unsubscribe(this);

        gd.layout.off("change:widthMain",this.debouncedSizeChanged,this);
        gd.layout.off("change:heightMain",this.debouncedSizeChanged,this);

        this.node.removeEventListener('click', this.handleAppMainClick, true);

        this.debouncedSizeChanged.cancel();
        gd.layout.setRightFilterOpen(false);
    }

    showRightContainer = (data:any) => {
        const { value, overlap } = data;

        if (value) this.addClass('is-filter-open');
        else this.removeClass('is-filter-open');

        gd.layout.setRightFilterOpen(value);

        this.overlap = !!overlap;
        this.onSizeChanged();
    }

    onSizeChanged = () => {

        const isInlineFilter = !this.overlap && gd.layout.widthMain > this.filterTypeEdge;
        if (isInlineFilter) this.addClass('inline-filter');
        else                this.removeClass('inline-filter');
    }

    handleAppMainClick = (event:any) => {
        //close right container on click in main app
        if (this.node.contains(event.target)) {
            gd.bus.triggerEvent("rightContainer:close-preferences")
        }
    }

    renderHeaderTitle() {
        const { title, navigation} = this.props;

        if (!title) return;

        const headerClass = Classes("title-label", {
            "with-nav": navigation
        });

        return (
            <div className="header-title">
                <div className={headerClass}>{title}</div>
            </div>
        );
    }

    renderHeader() {
        const { title, navigation, navigationHandler} = this.props;
        if (!title && !navigation && !navigationHandler) {
            return
        }

        return (
            <div className="header">
                {this.renderNavigation()}
                {this.renderHeaderTitle()}
                <div className="cf"> </div>
            </div>
        );
    }

    renderNavigation() {
        const { navigation, navigationHandler} = this.props;
        if (navigation) {
            const arrRes    : any[] = [];
            navigation.map(function(item,key){
                const sepKey = "s"+key;
                if (navigationHandler){
                    arrRes.push(<GDLink key={key} onClick={function(){navigationHandler(item.link)}}>{item.name}</GDLink>);
                } else {
                    arrRes.push(<GDLink key={key} href={item.link}>{item.name}</GDLink>);
                }
                arrRes.push(<div className="sep" key={sepKey}>  / </div>);
            });
            return arrRes;
        }
    }

    render() {

        const classes = Classes('main', this.props.type, this.props.className, {
            'inline-filter'     : !this.overlap && gd.layout.widthMain > this.filterTypeEdge,
            'is-filter-open'    : this.props.rightContainerOpen
        });

        return (
            <div className={classes} onScroll={this.props.onScroll}>
                {this.renderHeader()}
                {this.props.children}
            </div>
        );
    }
}
